import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from './Button';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  footer?: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  description,
  children,
  size = 'md',
  footer
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl'
  };
  return <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-294">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50 transition-opacity" onClick={onClose} data-id="element-295" />

      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4" data-id="element-296">
        <div className={`relative bg-white rounded-xl shadow-2xl w-full ${sizeClasses[size]} transform transition-all`} onClick={e => e.stopPropagation()} data-id="element-297">
          {/* Header */}
          <div className="flex items-start justify-between p-6 border-b border-slate-200" data-id="element-298">
            <div data-id="element-299">
              <h2 className="text-xl font-semibold text-slate-900" data-id="element-300">{title}</h2>
              {description && <p className="text-sm text-slate-500 mt-1" data-id="element-301">{description}</p>}
            </div>
            <button onClick={onClose} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-302">
              <X className="w-5 h-5" data-id="element-303" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6" data-id="element-304">{children}</div>

          {/* Footer */}
          {footer && <div className="flex items-center justify-end gap-3 p-6 border-t border-slate-200 bg-slate-50" data-id="element-305">
              {footer}
            </div>}
        </div>
      </div>
    </div>;
}